// Common language
export const DEFAULT_LANG_CODE = "en";
export const ARR_LANGUAGE = [{ key: 1, lang: "English", code: "en" }];

// Namespace Key
export const NS_COMMON = "common";
export const NS_REQUEST = "request";
export const NS_DEVICE = "device";
export const NS_APPLICATION = "application";
export const NS_USER = "user";
